const levelRegex = /Dist(\d+)/i;
export const parseDistance = (name) => {
    let level = null;
    const m = name.match(levelRegex);
    if (m !== null) {
        level = parseInt(m[1], 10);
    }
    return level;
};
